<template>
    <div class="asso-team-portal">
        <TournamentAddGameModal :association_id="association_id" :eventId="eventId" />
        <div class="asso-sec-content" v-if="tournamentsData.length > 0" :class="{ 'mt-3': tournamentGame.length > 0 }">
            <div class="d-flex justify-content-between flex-wrap align-items-center" style="gap: 5px;">
                <!-- Tournament Dropdown -->
                <div class="position-relative d-flex flex-wrap align-items-center" style="gap: 5px;">
                    <div class="dropdown-wrapper">
                        <div class="dropdown-button" :class="{
                            'has-value': selectedTournamentName,
                        }" @click="toggleDropdown" v-click-outside="closeDropdown">
                            <div>
                                <p class="association-data">{{ selectedTournamentName || "Division" }}</p>
                            </div>
                            <img :src="arrow_down" alt="arrow-down" />
                        </div>

                        <div class="dropdown-menu-content" v-if="activeDropdown">
                            <input v-model="searchQuery" type="text" class="form-control" placeholder="Search Division"
                                @click.stop @input="onSearchInput" />
                            <div v-if="filteredTournaments.length === 0" class="no-results">No results found</div>
                            <div class="dropdown-menu-content-inner" ref="dropdownMenu" v-else>
                                <div v-for="tournament in filteredTournaments" :key="tournament.guid"
                                    class="dropdown-item" @click="selectTournament(tournament)">
                                    <span>{{ tournament.tournamentName }}</span>
                                </div>
                                <div class="position-relative py-3" v-if="showLoaderTournament === 1">
                                    <div class="lds-dual-ring-media"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dropdown-wrapper" v-click-outside="closeDropdownTeam">
                        <button class="dropdown-button" :class="{
                            'has-value': selectedTeams.length > 0,
                        }" @click="toggleTeamDropdown">
                            <span>{{
                                selectedTeams.length >= 1
                                    ? selectedTeams[0]
                                    : "Teams"
                            }}</span>
                            <div class="badge-wrapper" v-if="selectedTeams.length > 1">
                                <span class="counter-badge">+{{ selectedTeams.length - 1 }}</span>
                            </div>
                            <img :src="arrow_down" alt="arrow-down" />
                        </button>
                        <div class="dropdown-menu-content" v-show="teamDropdownOpen">
                            <div v-if="showLoader" class="lds-dual-ring-refresh"></div>
                            <div class="data-wrap" v-if="!showLoader">
                                <input type="text" v-model="teamSearchQuery" placeholder="Search Teams"
                                class="form-control" @click.stop @input="onSearchInputTeam" />
                                <div class="dropdown-menu-content-inner">
                                    <div v-if="filteredTeams.length === 0 && !showLoader" class="no-results">
                                        No result found
                                    </div>
                                    <div v-else>
                                        <div v-for="team in filteredTeams" :key="team.id" class="dropdown-item"
                                            :class="{ selected: selectedTeams.includes(team.team.team_name) }"
                                            @click="toggleTeamSelection(team)">
                                            <input type="checkbox" :checked="selectedTeams.includes(team.team.team_name)"
                                                class="checkbox circular-checkbox" />
                                            <span>{{ team.team.team_name }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Clear Selection Button -->
                                <button class="clear-btn" @click.stop="clearTeamSelection"
                                    v-if="teamSearchQuery || selectedTeams.length > 0">
                                    Clear Selection
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class=" left-part-btns justify-content-start">
                        <button :class="{ active: selectedFilter === 'all' }" @click="filterGames('all')">
                            All
                        </button>
                        <button :class="{ active: selectedFilter === 'ongoing' }" @click="filterGames('ongoing')">
                            Ongoing
                        </button>
                        <button :class="{ active: selectedFilter === 'final' }" @click="filterGames('final')">
                            Final
                        </button>
                    </div>
                </div>

                <div class="d-flex justify-content-end" v-if="currentIsAdmin == '1'">
                    <button class="btn create-event" @click="callModal(selectedTournament)">
                        Add Game
                    </button>
                </div>
            </div>
            <TournamentGames ref="gameList" :currentIsAdmin="currentIsAdmin" :currentIsUmpire="currentIsUmpire"
                :tournamentData="tournamentsData" :showLoader="showLoaderTournament" :association_id="association_id" />
        </div>
    </div>
</template>

<script>
import TournamentGames from "../Tournaments/TournamentGames.vue";
import TournamentAddGameModal from "../Tournaments/Modals/TournamentAddGameModal.vue";
import axios from "axios";

export default {
    name: "AssociationBoxScoresInfo",
    components: {
        TournamentGames,
        TournamentAddGameModal,
    },
    data() {
        return {
            searchQuery: '',
            showLoader: 1,
            tournamentGame: [],
            selectedTournament: null,
            activeDropdown: false,
            previousScrollTop: 0,
            arrow_down: require('@/assets/Svg/arrow-down.svg'),
            events: {},
            selectedFilter: localStorage.getItem("gameFilter") || "all", // Default filter

            teamData: [],
            selectedTeams: [],
            teamDropdownOpen: false,
            teamSearchQuery: '',
            page: 1,
            teamLastPage: 1,
            search_icon: require('@/assets/Svg/Search.svg'),
        };
    },
    computed: {
        selectedTournamentName() {
            const tournament = this.tournamentsData.find(t => t.guid === this.selectedTournament);
            return tournament ? tournament.tournamentName : "";
        },
        sortedTournaments() {
            if (!this.tournamentsData) return [];
            return [...this.tournamentsData].sort((a, b) => {
                const nameA = (a.tournamentName || "").toUpperCase();
                const nameB = (b.tournamentName || "").toUpperCase();
                return nameA.localeCompare(nameB);
            });
        },
        filteredTournaments() {
            const query = this.searchQuery.trim().toLowerCase();
            return this.sortedTournaments.filter(t =>
                (t.tournamentName || '').toLowerCase().includes(query)
            );
        },
        filteredTeams() {
            const query = this.teamSearchQuery.trim().toLowerCase();
            return this.teamData.filter(team =>
                (team.team.team_name || '').toLowerCase().includes(query)
            );
        },
        selectedTeamNames() {
            return this.selectedTeams.map(teamId => {
                const team = this.teamData.find(t => t.id === teamId);
                return team ? team.team.team_name : '';
            }).join(', ');
        }
    },
    watch: {
        tournamentsData: {
            handler(newData) {
                if (!newData || newData.length === 0) return;

                // Create a sorted copy
                const sortedData = [...newData].sort((a, b) => {
                    const nameA = (a.tournamentName || '').toUpperCase();
                    const nameB = (b.tournamentName || '').toUpperCase();
                    return nameA.localeCompare(nameB);
                });

                const storedTournamentID = localStorage.getItem("tournamentID");

                if (storedTournamentID) {
                    this.selectedTournament = storedTournamentID;
                    this.getTournamentTeams(storedTournamentID);
                } else {
                    this.selectedTournament = sortedData[0].guid;
                    localStorage.setItem("tournamentID", this.selectedTournament);
                    this.getTournamentTeams(this.selectedTournament);
                }
            },
            immediate: true
        },

        currentIsUmpire: {
            immediate: true,
            handler(umpire) {
                if (umpire === 1 || umpire === '1') {
                    this.getTournamentDetail();
                }
            }
        }
    },
    props: {
        tournamentsData: {
            type: Array,
        },
        showLoaderTournament: {
            type: Number,
        },
        currentIsUmpire: {
            type: String,
        },
        currentIsAdmin: {
            type: String,
        },
        eventId: {
            // Define umpires prop to receive the umpire data
            type: Number,
        },
        association_id: {
            type: Number,
        },
        divisionPage: {
            type: Number,
        },
        divisionlastPage: {
            type: Number,
        },
    },
    methods: {
        onSearchInput(e) {
            this.searchQuery = e.target.value;
        },
        onSearchInputTeam(e) {
            this.teamSearchQuery = e.target.value;
        },
        callModal(tournament) {
            this.$root.$emit("openTournamentAddGameModal", tournament);
        },
        toggleDropdown() {
            this.searchQuery = '';
            this.activeDropdown = !this.activeDropdown;

            this.$nextTick(() => {
                if (this.activeDropdown && this.$refs.dropdownMenu) {
                    this.$refs.dropdownMenu.addEventListener("scroll", this.onDropdownScroll);
                } else if (this.$refs.dropdownMenu) {
                    this.$refs.dropdownMenu.removeEventListener("scroll", this.onDropdownScroll);
                }
            });
        },
        onDropdownScroll() {
            this.$emit("get-division-pagination");
        },
        closeDropdown() {
            this.activeDropdown = false;
        },
        toggleTeamDropdown() {
            this.teamDropdownOpen = !this.teamDropdownOpen;
        },

        toggleTeamSelection(team) {
            const teamName = team.team.team_name;
            const index = this.selectedTeams.indexOf(teamName);
            if (index === -1) {
                this.selectedTeams.push(teamName); // Store the full object
            } else {
                this.selectedTeams.splice(index, 1); // Remove by index
            }
            // Emit event with selected team names
            this.$root.$emit("filterGamesByTeams", this.selectedTeams);
        },

        clearTeamSelection() {
            this.selectedTeams = [];
            this.teamSearchQuery = '';
            this.$root.$emit("filterGamesByTeams", []);
        },

        closeDropdownTeam() {
            this.teamDropdownOpen = false;
        },

        async selectTournament(tournament) {
            this.selectedTournament = tournament.guid;
            this.teamData = []; // Clear existing teams data
            this.selectedTeams = []; // Clear selected teams
            this.page = 1;
            await this.getTournamentTeams(tournament.guid);
            this.$root.$emit("changeDivision", this.selectedTournament);
            localStorage.setItem("division", this.selectedTournament);
            this.closeDropdown();
        },
        async getTournamentDetail() {
            var url = window.location.pathname;
            var segment_array = url.split("/");
            const tournamentGuid = segment_array.pop();
            this.showLoader = 1;
            try {
                const response = await axios.post(
                    `${process.env.VUE_APP_API_URL}tournaments/getEventGames`,
                    { event_guid: tournamentGuid }
                );

                if (response.data.statusCode === 200) {
                    this.tournamentGame = response.data.data.tournamentGames && response.data.data.tournamentGames ? response.data.data.tournamentGames : [];
                    this.events = response.data.data.teamEventData;
                    this.currentIsAdmin = this.events.currentIsAdmin === "1" ? "1" : "0";
                    this.currentIsUmpire = this.events.currentIsAdmin === "0" ? "0" : "1";
                    this.showLoader = 0;
                } else if (response.data.statusCode === 404 || response.data.statusCode === 403) {
                    this.$alert(response.data.message, 'Error');
                    this.$router.push({ name: "Teams" });
                    this.showLoader = 0;
                } else if (response.data.statusCode === 400) {
                    this.showLoader = 0;
                    this.$alert("Tournament not found").then(() => {
                        window.history.back();
                    });
                } else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoader = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoader = 0;
            } finally {
                this.showLoader = 0;
            }
        },
        async getTournamentTeams(guid) {
            this.showLoader = 1;
            try {
                const response = await axios.post(
                    `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentTeams`,
                    { tournament_guid: guid ? guid : this.tournamentData[0].guid, page: this.page, association_id: this.association_id, } // Include the page parameter
                );

                if (response.data.statusCode === 200) {
                    const newData = response.data.data.data;
                    newData.sort((a, b) => a.team_sr_no - b.team_sr_no);
                    this.teamData = [...this.teamData, ...newData]; // Concatenate the new data with existing data
                    this.teamLastPage = response.data.data.last_page;
                    this.showLoader = 0;
                } else if (response.data.statusCode === 404) {
                    this.$alert(response.data.message, "Error");
                    this.$router.push({ name: "Teams" });
                    this.showLoader = 0;
                } else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoader = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoader = 0;
            } finally {
                this.showLoader = 0;
            }
        },
        filterGames(filter) {
            this.selectedFilter = filter;
            localStorage.setItem('gameFilter', this.selectedFilter);
            this.$root.$emit("FilterGames", this.selectedFilter);
        },
    },
};
</script>